import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {

  @Input() showloader = false;
  loaderSubscription: Subscription;
  constructor(private loaderService: LoaderService) {
  }

  ngOnInit() {
    this.loaderSubscription = this.loaderService.getLoader().subscribe(value => {
      this.showloader = value;
    });
  }

ngOnDestroy(){
  this.loaderSubscription.unsubscribe();
}

}
